import React from "react";
import { useCareManagementQuery } from "../../../hooks/queries/useCareManagementQuery";
import { useAppSelector } from "../../../store/hooks";
import { ClinicalProgressionPanel } from "../ClinicalProgression";
import CairePollingShell from "../CairePollingShell";

const ReadmissionRisk: React.FC = () => {
  const mrn = useAppSelector((state) => state.fhir.mrn) ?? "";
  const providerNpi = useAppSelector((state) => state.provider.providerNPI);
  const { data, isLoading, isFetching, isError } = useCareManagementQuery(
    mrn,
    providerNpi,
    { polling: true }
  );

  if (isLoading)
    return (
      <p className="p-4 text-sm text-gray-500">
        Loading care management data...
      </p>
    );
  if (isError)
    return (
      <p className="p-4 text-sm text-red-600">
        Unable to load care management data.
      </p>
    );
  if (!data?.review)
    return (
      <p className="p-4 text-sm text-gray-500">
        No care management query is assigned for this patient.
      </p>
    );

  return (
    <CairePollingShell refreshing={isFetching && !isLoading}>
      <ClinicalProgressionPanel
        drivers={data.review.diagnosisReadmissionDrivers ?? []}
        comorbidity={data.review.comorbidityComplexityAnalysis ?? null}
      />
    </CairePollingShell>
  );
};

export default ReadmissionRisk;
